import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
  sClientName1: "",
  sdepartment: "",
  pbCalcCostFromScopes: false,
  pdtEffectiveDate: null,
  pdtEndDate: null,
  pbNonBillable: false,
  pnCost: "",
  psPONumber: "",
};

export const editDepartmentConfig = {
  name: "Edit Contract Department",
  initialState: initialState,
  section: [
    {
      sectionId: "editDepartmentSection1",
      title: "Edit Contract Department",
      row: {},
      style: {
        sectionStyle: "",
      },
      wrapperTemplate: <div className=""></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "sClientName1",
          label: "Client :",
          Field_Name: "Client",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sClientName1",
          fieldSetting: {
            placeholder: "Enter Client Name 1",
            isDisable: true,
          },
          style: {
            containerCss: "col-12 mb-2",
          },
        },
        {
          id: "sdepartment",
          label: "Department :",
          Field_Name: "Department",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sdepartment",
          fieldSetting: {
            placeholder: "Department",
            isDisable: true,
          },
          style: {
            containerCss: "col-12 mb-2",
          },
        },
        {
          id: "pbCalcCostFromScopes",
          label: "Calc Cost From Scopes :",
          Field_Name: "calc Cost From Scopes",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "pbCalcCostFromScopes",
          fieldSetting: {
            placeholder: "  ",
            hasMainTitle: "Calc Cost From Scopes :",
          },
          style: {
            containerCss:
              "col-xxl-6 col-xl-6 col-lg-6 col-12 mb-2 double-label-sec mt-3",
          },
        },
        {
          id: "pnCost",
          label: "Contract Cost :",
          Field_Name: "Contract Cost",
          fieldType: FormFieldTypes.INPUT,
          dataField: "pnCost",
          fieldSetting: {
            placeholder: "Enter Contract Cost ",
            isDisable: false,
          },
          style: {
            containerCss: "col-12 mb-2",
          },
        },
        {
          id: "pdtEffectiveDate",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "pdtEffectiveDate",
          fieldSetting: {
            placeholder: "Effective Date",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "pdtEndDate",
          label: "End Date :",
          Field_Name: "End Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "pdtEndDate",
          fieldSetting: {
            placeholder: "End Date",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },
        {
          id: "pbNonBillable",
          label: "Non-Billable :",
          Field_Name: "Non-Billable",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "pbNonBillable",
          fieldSetting: {
            placeholder: "  ",
            hasMainTitle: "Bill Type :",
          },
          style: {
            containerCss:
              "col-xxl-6 col-xl-6 col-lg-6 col-12 mb-2 double-label-sec mt-3",
          },
        },
        {
          id: "psPONumber",
          label: "PO Number :",
          Field_Name: "PO NUmber",
          fieldType: FormFieldTypes.INPUT,
          dataField: "psPONumber",
          fieldSetting: {
            placeholder: "Enter PO Number",
            isEnableOnChange: true,
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
      ],
    },
  ],
};
